import type { ReactNode } from 'react';

export type InformationItem = { id: string; label: string; value: ReactNode; fullWidth?: boolean };

export function InformationList({ items }: { items: InformationItem[] }) {
  return (
    <dl className="grid grid-cols-1 gap-x-6 gap-y-4 text-sm sm:grid-cols-2">
      {items.map(({ id, label, value, fullWidth }) => (
        <div key={id} className={fullWidth ? 'sm:col-span-2' : undefined}>
          <dt className="text-xs text-muted-foreground">{label}</dt>
          <dd className="mt-1 font-medium break-words whitespace-pre-line">
            {value ?? <span className="text-muted-foreground">—</span>}
          </dd>
        </div>
      ))}
    </dl>
  );
}
